<template>
  <div class="all">
    <!-- 底部 -->
    <mall-fotter></mall-fotter>
    <!-- 顶部导航 -->
    <mall-header ref="header"></mall-header>
    <!-- 内容 -->
    <div class="content">
      <!-- 轮播图 -->
      <div class="rotation">
        <!-- 轮播图 -->
        <el-carousel height="401px">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <img :src="item.banner_url">
          </el-carousel-item>
        </el-carousel>
        <!-- 搜索框 -->
        <div class="searchFrame">
          <div class="search">
            <!-- 选项 -->
            <div class="searchRadio txt_a_l">
              <el-radio fill="#fff" v-model="searchRadio" label="0">全部</el-radio>
              <el-radio fill="#fff" v-model="searchRadio" label="1">冰场</el-radio>
              <el-radio fill="#fff" v-model="searchRadio" label="2">雪场</el-radio>
              <el-radio fill="#fff" v-model="searchRadio" label="3">住滑</el-radio>
            </div>
            <!-- 搜索框 -->
            <div class="searchDetail ovh">
              <div class="inputDiv f_l">
                <input class="input" placeholder="请输入关键字" v-model="searchTxt" />
              </div>
              <div class="f_r searchButton txt_a_c">点击搜索</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 人数 -->
      <div class="product">
        <div class="productAll">
          <!-- 人数 -->
          <div class="people ovh">
            <div class="peopleList people_1 f_l ovh">
              <div class="peopleListNum f_r ovh">
                <div class="f_l" v-for="(item, i) in orderCountList" :key="i">{{item}}</div>
              </div>
              <div class="peopleListLable f_r" v-if="orderCountList.length > 0">累计卖出雪票</div>
            </div>
            <div class="peopleList people_2 f_l ovh">
              <div class="peopleListLable f_l" v-if="userCountList.length > 0">累计注册人数</div>
              <div class="peopleListNum f_l ovh">
                <div class="f_l" v-for="(user, i) in userCountList" :key="i">{{user}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 雪场专区 -->
      <div class="product" v-for="(item, index) in websiteList" :key="index">
        <!-- 专区 -->
        <div class="productAll">
          <!-- 地区 -->
          <div class="address ovh">
            <!-- 地区 -->
            <div class="addressName f_l">{{item.area_name}}</div>
            <!-- 图片 -->
            <div class="addressImg f_l ovh">
              <div>
                <p>选择</p>
                <p>雪场</p>
              </div>
            </div>
            <div class="addressImgAll ovh">
              <!-- 地址图片数组 -->
              <div class="addressImgList f_l ovh" v-for="(field, field_i) in item.fieldList" :key="field_i"
                :class="fieldSelect[index] == field.field_id ? 'select' : ''"
                @click="fieldListSelect(index, field.field_id)">
                <img :src="field.image" />
              </div>
            </div>
          </div>
          <!-- tab -->
          <div class="productTab">
            <div class="productTabListAll ovh">
              <!-- 票类型 -->
              <div class="productTabList f_l" v-for="(category, i) in categoryList" :key="i" :class="categorySelect[index] == category.id ? 'tabListSelect' : ''"
                @click="categoryListSelect(index, category.id)">
                {{category.name}}
                <div class="productTabListImg" v-if="categorySelect[index] == category.id"><img src="../../static/index/tab_bottom.png" /></div>
              </div>
            </div>
            <div class="xian" v-if="categoryList.length > 0"></div>
          </div>
          <!-- 分类 -->
          <div class="ificationAll ovh">
            <div class="ificationAllLeft f_l ovh">
              <div class="ificationListAll ovh" v-if="false">
                <div class="ificationList txt_a_c f_l">优惠促销</div>
                <div class="ificationList txt_a_c f_l">爆款特卖</div>
                <div class="ificationList txt_a_c f_l">优质服务</div>
                <div class="ificationList txt_a_c f_l">亲子专线</div>
                <div class="ificationList txt_a_c f_l">蜜月首选</div>
              </div>
            </div>
            <div class="sequence f_r ovh" @click="sortListSelect(index, sortSelect[index])">
              <div class="f_r sequence_font">{{sortSelect[index] == 1 ? '价格降序' : '价格升序'}}</div>
              <div class="f_r sequence_img">
                <!-- <img :src="sortSelect[index] == 1 ? '@/static/index/sequence_img_bottom.png' : '@/static/index/sequence_img_top.png'" /> -->
                <img v-if="sortSelect[index] == 1" src="../../static/index/sequence_img_bottom.png" />
                <img v-if="sortSelect[index] == 2" src="../../static/index/sequence_img_top.png" />
              </div>
            </div>
          </div>
          <!-- 产品列表 -->
          <div class="productListAll ovh">
            <!-- 列表 -->
            <div class="productList f_l ovh" v-for="(commodity, k) in commodityList[index]" :key="k" @click="detail(commodity)">
              <!-- 产品图片 -->
              <div class="productListImg f_l ovh">
                <img :src="commodity.cover" />
              </div>
              <!-- 产品内容 -->
              <div class="popularListCont f_l ovh">
                <div class="popularListCont_txt twoRow">
                  {{commodity.goods_name}}
                </div>
                <div class="popularListCont_money txt_a_r">
                  <span>￥{{commodity.price}}</span>起
                </div>
              </div>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="snowFieldButton txt_a_c">查看更多产品</div>
        </div>
      </div>
      <!-- 爆款产品推荐 -->
      <div class="popular" v-if="false">
        <div class="popularAll">
          <div class="popularAll_title">
            <img src="../../static/title_2.png" />
          </div>
          <div class="popular_huan ovh">
            <div class="f_r"></div>
            <div class="f_r">换一换</div>
          </div>
          <!-- 列表 -->
          <div class="popularListAll ovh">
            <div class="popularList f_l ovh" v-for="(item, index) in 6" :key="index">
              <!-- 产品图片 -->
              <div class="popularListImg f_l">
                <img src="../../static/ce.png" />
              </div>
              <!-- 产品内容 -->
              <div class="popularCont f_l">
                <!-- 标题 -->
                <div class="popularCont_tit twoRow">[松花湖]花开富贵酒店周末双床房两住两滑</div>
                <!-- 类别 -->
                <div class="popularCont_tab ovh">
                  <div class="popularCont_tabList f_l">免费停车场</div>
                  <div class="popularCont_tabList f_l">共享充电宝</div>
                </div>
                <!-- 钱 -->
                <div class="popularContMoney txt_a_r">￥2416</div>
                <!-- 优惠 -->
                <div class="popularContDiscount ovh">
                  <div class="money f_l">最高优惠98元</div>
                  <div class="num f_r">累计销量123</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="popularButton txt_a_c">查看更多产品</div>
        </div>
      </div>
      <!-- 雪场介绍 -->
      <div class="snowField">
        <!-- 雪场标题 -->
        <div class="snowFieldTitle ovh">
          <div class="f_l xian"></div>
          <div class="f_l snowFieldTitleImg"><img src="../../static/title_1.png" /></div>
          <div class="f_r xian"></div>
        </div>
        <!-- 雪场列表 -->
        <div class="snowFieldAll ovh">
          <!-- 列表 -->
          <div class="snowFieldList f_l ovh" v-for="(item, index) in getFieldList" :key="index" @click="snowFieldListDetail(item.id)">
            <!-- 图片 -->
            <div class="snowFieldList_img">
              <img :src="item.banner" />
              <div class="snowFieldImg f_l ovh">
                <img :src="item.header_pic" />
              </div>
            </div>
            <!-- 内容 -->
            <div class="snowFieldList_cont">
              <!-- 标题 -->
              <div class="snowFieldList_cont_title ovh">
                <div class="snowFieldList_cont_contDet f_l">
                  <p class="txt_a_l snowFieldList_cont_contDet_tit">{{item.name}}</p>
                  <p class="txt_a_l snowFieldList_cont_contDet_name">{{item.count}}</p>
                </div>
              </div>
              <!-- 内容 -->
              <div class="snowFieldList_cont_detil threeRow">
                {{item.description}}
              </div>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="snowFieldButton txt_a_c">查看更多产品</div>
      </div>
    </div>
  </div>
</template>

<script>
  // 引入共用的css
	import "../components/css/component.css";
  import "../components/css/input.css";

  // 顶部导航
  import mallHeader from '@/components/headTop.vue';
  // 底部
  import mallFotter from '@/components/fotter.vue';

  // 调用的接口
  import { getIndexBannerList, getIndexWebsiteList, getIndexCommodityList, getIndexFieldList } from '@/request/api.js';
  import { numToArray } from '@/utils/utils.js'
  import { baseUrl } from '@/request/request.js'

  export default {
    name: 'index',
    data () {
      return {
        bannerList: [], // 轮播图
        searchRadio: '0', // 搜索类别
        radioList: [], // 搜索类别数组
        searchTxt: '', // 搜索内容
        orderCountList: [], // 累计卖出门票
        userCountList: [], // 累计注册人数
        websiteList: [], // 雪场列表
        categoryList: [], // 票类型
        fieldSelect: [], // 雪场选中的id
        categorySelect: [], // 票类型选中的id
        sortSelect: [], // 排序选中
        commodityList: [], // 商品列表
        getFieldList: [] // 获取底部雪场列表
      }
    },

    // 引用顶部和底部
    components:{
      'mall-header': mallHeader, // 顶部导航
      'mall-fotter': mallFotter // 底部导航
    },

    mounted() {
      // 导航选择
      this.navigation(0);
      // 获取雪场列表
      this.getWebsiteList();
      // 获取轮播图
      this.getBannerList();
      // 获取底部雪场列表
      this.getBottomFieldList();
    },

    computed:{
      
    },

    methods:{
      // 获取轮播图
      getBannerList() {
        // 调用获取轮播图接口
        getIndexBannerList().then(res => {
          if(res.code == 0) {
            var row = res.data;
            for(let i in row) {
              row[i].banner_url = baseUrl() + row[i].banner_url
            }
            // 轮播图数组赋值
            this.bannerList = row;
          }
        })
      },

      // 获取雪场列表
      getWebsiteList() {
        // 调用获取雪场列表接口
        getIndexWebsiteList({
          token: localStorage.getItem('token')
        }).then(res => {
          if(res.code == 0) {
            // 累计卖出门票
            this.orderCountList = numToArray(res.data.order_count);
            // 累计注册人数
            this.userCountList = numToArray(res.data.user_count);
            // 雪场
            var row = res.data.area;
            for(let i in row) {
              // 雪场默认选中第一个
              this.fieldSelect.push(row[i].fieldList[0].field_id);
              // 票类型默认选中第一个
              this.categorySelect.push(res.data.category[0].id);
              // 排序选中
              this.sortSelect.push(1);
              // 获取商品列表
              this.getCommodityList(i);
              // 循环图片添加服务器地址
              for(let j in row[i].fieldList) {
                row[i].fieldList[j].image = baseUrl() + row[i].fieldList[j].image;
              }
            }
            // 雪场列表赋值
            this.websiteList = row;
            // 票类型
            this.categoryList = res.data.category;
          }
        })
      },

      // 获取底部雪场列表
      getBottomFieldList() {
        // 调用雪场列表接口
        getIndexFieldList({
          area_type: 1,
          token: localStorage.getItem('token')
        }).then(res => {
          if(res.code == 0) {
            if(res.data.length > 0) {
              let list = [];
              for(let i in res.data) {
                if(i < 6) {
                  list.push(res.data[i])
                }
              }
              var row = list;
              for(let k in row) {
                row[k].banner = baseUrl() + row[k].banner;
                row[k].header_pic = baseUrl() + row[k].header_pic;
              }
              // 底部雪场列表赋值
              this.getFieldList = row;
            }
          }
        })
      },

      // 获取商品列表
      getCommodityList(index) {
        // 调用获取商品列表接口
        getIndexCommodityList({
          dep_id: this.fieldSelect[index], // 雪场id
          category: this.categorySelect[index], // 票类型
          sort: this.sortSelect[index], // 序列
          token: localStorage.getItem('token')
        }).then(res => {
          console.log(res)
          if(res.code == 0) {
            var list = res.data.list;
            for(let i in list) {
              list[i].cover = baseUrl() + list[i].cover;
            }
            // 数组列表赋值
            this.$set(this.commodityList, index, list);
          }
        })
      },

      // 选择雪场
      fieldListSelect(index, id) {
        // 雪场id赋值
        this.$set(this.fieldSelect, index, id);
        // 获取商品列表
        this.getCommodityList(index);
      },

      // 选择票类型
      categoryListSelect(index, id) {
        // 票类型id赋值
        this.$set(this.categorySelect, index, id);
        // 获取商品列表
        this.getCommodityList(index);
      },

      // 选择升序/降序
      sortListSelect(index, sort) {
        // 升降序赋值(1：降序  2：升序)
        this.$set(this.sortSelect, index, parseInt(sort) == 1 ? 2 : 1);
        // 获取商品列表
        this.getCommodityList(index);
      },

      // 导航选择
      navigation(code) {
        this.$nextTick(() => {
          this.$refs.header.init(code)
        })
      },

      // 跳转雪票详情
      detail(item) {
        localStorage.setItem('goodId', item.id);
        localStorage.setItem('fieldId', item.field_id);
        this.$router.push({
          name: 'commodityDetail',
          params: {
            'id': item.id // 商品id
          }
        })
      },

      // 跳转雪场详情
      snowFieldListDetail(id) {
        var url = window.location.href;
        var index = url.lastIndexOf("\/");
        var str = url.substring(0, index + 1);
        localStorage.setItem('skiResortId', id)
        window.open(str + 'skiResortDetail');
      }
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  .content {
    padding: 50px 0 530px 0;
    // 轮播图
    > .rotation {
      min-width: 1200px;
      height: 401px;
      position: relative;
      // 搜索
      > .searchFrame {
        position: absolute;
        width: 100%;
        height: 115px;
        left: 0;
        bottom: 31px;
        z-index: 0;
        > .search {
          width: 620px;
          height: 100%;
          margin: 0 auto;
          background-color: rgba(0,0,0,.5);
          border-radius: 8px;
          padding: 0 13px;
          > .searchRadio {
            padding: 19px 0 12px 0;
            box-sizing: border-box;
          }
          // 搜索栏
          >.searchDetail {
            height: 50px;
            line-height: 50px;
            > .inputDiv {
              width: 80%;
            }
            // 搜索按钮
            > .searchButton {
              width: 20%;
              font-size: 18px;
              letter-spacing: 2px;
              color: #fff;
              background-color: #FF7702;
              border-top-right-radius: 8px;
              border-bottom-right-radius: 8px;
            }
          }
        }
      }
    }
    // 产品
    > .product {
      min-width: 1200px;
      cursor: pointer;
      >.productAll {
        width: 1200px;
        margin: 0 auto;
        // 人数
        &> .people {
          padding: 22px 0;
          &> .peopleList {
            width: 50%;
            &> .peopleListLable {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #2B2A25;
              line-height: 22px;
              letter-spacing: 1px;
              height: 36px;
              line-height: 36px;
              margin-right: 19px;
            }
            &> .peopleListNum {
              &> div {
                width: 36px;
                height: 36px;
                line-height: 36px;
                border-radius: 8px;
                border: 2px solid #BAB9B9;
                margin-right: 4px;
                color: #FF7702;
                font-weight: bold;
              }
              &> div:last-child {
                margin-right: 0;
              }
            }
          }
          &> .people_1 {
            padding-right: 30px;
            box-sizing: border-box;
          }
          &> .people_2 {
            padding-left: 30px;
            box-sizing: border-box;
          }
        }
        // 地区
        &> .address {
          height: 100px;
          &> .addressName {
            width: 150px;
            height: 100%;
            font-size: 30px;
            padding-top:  40px;
            box-sizing: border-box;
            background: #FF7702;
            color: #fff;
            border-radius: 8px;
          }
          &> .addressImg {
            width: 100px;
            height: 100px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            > div {
              width: 51px;
              height: 56px;
              letter-spacing: 1px;
              font-size: 20px;
              color: #3D3D3D;
            }
          }
          &> .addressImgAll {
            &> .addressImgList {
              width: 100px;
              height: 100px;
              border-radius: 8px;
              margin-right: 16px;
            }
            &> .addressImgList:last-child {
              margin-right: 0;
            }
            // 选中雪场
            &> .select {
              border: 1px solid #ff7702;
              height: 98px;
            }
          }
        }
        // tab选项
        &> .productTab {
          position: relative;
          &> .productTabListAll {
            &> .productTabList {
              color: #9C9C9C;
              margin-right: 48px;
              letter-spacing: 2px;
              position: relative;
              height: 86px;
              line-height: 86px;
              font-size: 20px;
              &> .productTabListImg {
                position: absolute;
                bottom: 33px;
                width: 77px;
                height: 21px;
                z-index: 1;
              }
            }
            &> .tabListSelect {
              font-size: 24px;
              color: #FF7702;
            }
          }
          &> .xian {
            position: absolute;
            left: 0;
            bottom: 11px;
            width: 1200px;
            height: 4px;
            background: #E3E4E4;
            border-radius: 2px;
          }
        }
        // 分类
        &> .ificationAll {
          padding: 15px 0 22px 0;
          font-size: 18px;
          color: #0F7DFF;
          letter-spacing: 1px;
          &> .ificationAllLeft {
            width: 1050px;
            &> .ificationListAll {
              width: 100%;
              &> .ificationList {
                width: 68px;
                font-size: 16px;
                height: 30px;
                line-height: 30px;
                padding: 0 15px;
                background: #EBF4FF;
                border-radius: 15px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                letter-spacing: 1px;
                margin-right: 20px;
              }
              &> .ificationList:last-child {
                margin-right: 0;
              }
            }
          }
          &> .sequence {
            &> .sequence_img {
              width: 20px;
              height: 18px;
              margin: 3px 6px 0 0;
            }
            &> .sequence_font {
              font-size: 17px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
            }
          }
        }
        // 产品列表
        &> .productListAll {
          width: 100%;
          // 列表
          &> .productList {
            width: 19.2%;
            margin-right: 1%;
            margin-bottom: 20px;
            border-radius: 8px;
            box-shadow: 2px 2px 5px 0px rgba(204, 205, 205, 0.5);
            // 图片
            .productListImg {
              width: 100%;
              height: 230.39px;
              border-top-left-radius: 8px;
              border-top-right-radius: 8px;
            }
            // 内容
            .popularListCont {
              width: 100%;
              height: 80px;
              border-bottom-left-radius: 8px;
              border-bottom-right-radius: 8px;
              padding: 7px 12px;
              box-sizing: border-box;
              > .popularListCont_txt {
                height: 44px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #2B2A25;
                line-height: 22px;
                text-shadow: 2px 2px 5px rgba(204, 205, 205, 0.5);
                text-align: justify;
              }
              > .popularListCont_money {
                font-size: 14px;
                color: #E74C1F;
                > span {
                  font-size: 20px;
                  margin-right: 3px;
                }
              }
            }
          }
          &> .productList:nth-child(5n) {
            margin-right: 0;
          }
        }
        &> .snowFieldButton {
          width: 189px;
          height: 46px;
          line-height: 46px;
          background: #EBF4FF;
          border-radius: 8px;
          margin: 39px auto;
          margin-top: 19px !important;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2B2A25;
        }
      }
    }
    // 爆款产品推荐
    > .popular {
      min-width: 1200px;
      height: 487px;
      background: linear-gradient(180deg, #22B4FF 0%, #0F7DFF 100%);
      > .popularAll {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        padding: 30px 0;
        box-sizing: border-box;
        > .popularAll_title {
          width: 236px;
          height: 24px;
          margin: 0 auto;
        }
        > .popular_huan {
          font-size: 14px;
          color: #fff;
          cursor: pointer;
          margin-top: 14px;
        }
        >.popularListAll {
          margin-top: 10px;
          >.popularList {
            width: 32%;
            height: 140px;
            margin-right: 2%;
            background: #FFFFFF;
            border-radius: 8px;
            background: #fff;
            margin-bottom: 20px;
            // 产品图片
            .popularListImg {
              width: 140px;
              height: 140px;
              border-top-left-radius: 8px;
              border-bottom-left-radius: 8px;
            }
            // 产品内容
            .popularCont {
              width: 60%;
              height: 100%;
              padding-left: 12px;
              box-sizing: border-box;
              // 标题
              > .popularCont_tit {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                color: #2B2A25;
                line-height: 22px;
                text-align: justify;
                letter-spacing: 1px;
                font-weight: bold;
                margin-top: 3px;
              }
              // 类别
              > .popularCont_tab {
                margin-top: 12px;
                > .popularCont_tabList {
                  font-size: 11px;
                  font-weight: 400;
                  color: #0F7DFF;
                  line-height: 16px;
                  padding: 0 4px;
                  border-radius: 4px;
                  border: 1px solid #0F7DFF;
                  margin-right: 5px;
                }
              }
              // 产品钱
              > .popularContMoney{
                height: 38px;
                line-height: 34px;
                font-size: 20px;
                font-family: Helvetica;
                color: #E74C1F;
              }
              // 优惠
              > .popularContDiscount {
                > .money {
                  font-size: 12px;
                  color: #fff;
                  height: 18px;
                  line-height: 18px;
                  background: linear-gradient(90deg, #FFE200 0%, #E74C1F 100%);
                  border-radius: 3px;
                  padding: 0 4px;
                }
                > .num {
                  font-size: 10px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #7F7E7D;
                  line-height: 14px;
                }
              }
            }
          }
          >.popularList:nth-child(3n) {
            margin-right: 0;
          }
        }
        // 按钮
        >.popularButton {
          cursor: pointer;
          width: 189px;
          height: 46px;
          line-height: 46px;
          background: #fff;
          border-radius: 8px;
          margin: 0 auto;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2B2A25;
        }
      }
    }
    // 雪场介绍
    > .snowField {
      width: 1200px;
      margin: 0 auto;
      > .snowFieldTitle {
        margin: 50px 0 40px 0;
        > .xian {
          width: 43%;
          height: 4px;
          background: #E3E4E4;
          border-radius: 2px;
          margin-top: 10px;
        }
        >.snowFieldTitleImg {
          width: 10%;
          height: 27px;
          margin: 0 2%;
        }
      }
      > .snowFieldAll {
        height: 740px;
        cursor: pointer;
        > .snowFieldList {
          width: 32.66666666666667%;
          height: 350px;
          background: #fff;
          margin-right: 1%;
          box-shadow: 2px 2px 5px 0px rgba(204, 205, 205, 0.5);
          border-radius: 8px;
          margin-bottom: 20px;
          > .snowFieldList_img {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            height: 214px;
            width: 100%;
            position: relative;
            > .snowFieldImg {
              position: absolute;
              top: 195px;
              left: 21px;
              width: 62px;
              height: 62px;
              border-radius: 50%;
            }
          }
          > .snowFieldList_cont {
            height: 136px;
            width: 100%;
            padding: 4px 21px;
            box-sizing: border-box;
            > .snowFieldList_cont_title {
              > .snowFieldList_cont_contDet {
                padding-left: 82px;
                box-sizing: border-box;
                > .snowFieldList_cont_contDet_tit {
                  font-size: 14px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #0F7DFF;
                  line-height: 20px;
                  letter-spacing: 1px;
                  text-shadow: 2px 2px 5px rgba(204, 205, 205, 0.5);
                }
                > .snowFieldList_cont_contDet_name {
                  margin-top: 5px;
                  font-size: 16px;
                  font-family: Helvetica;
                  color: #434444;
                  line-height: 19px;
                  letter-spacing: 1px;
                  text-shadow: 2px 2px 5px rgba(204, 205, 205, 0.5);
                }
              }
            }
            > .snowFieldList_cont_detil {
              margin-top: 10px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #434444;
              line-height: 17px;
              letter-spacing: 1px;
              text-shadow: 2px 2px 5px rgba(204, 205, 205, 0.5);
              text-align: justify;
            }
          }
        }
        .snowFieldList:nth-child(3n) {
          margin-right: 0;
        }
      }
      > .snowFieldButton {
        cursor: pointer;
        width: 189px;
        height: 46px;
        line-height: 46px;
        background: #EBF4FF;
        border-radius: 8px;
        margin: 39px auto;
        margin-top: 30px !important;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2B2A25;
      }
    }
  }
  .el-carousel__item.is-active {
    z-index: 0;
  }
  .input {
    font-size: 18px;
    width: 100%;
    height: 50px;
    line-height: 50px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    background: #fff;
    padding: 0 17px;
    box-sizing: border-box;
    letter-spacing: 1px;
  }
</style>
<style scoped lang="">
  .el-carousel__button {
    display: none;
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: #fff;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #FE951E;
    background: #FE951E;
  }

  .el-radio__label {
    font-size: 16px !important;
    letter-spacing: 1px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/page/index.vue